module.exports = __webpack_public_path__ + "dsf_elogo.png?af4e778f6e23fe20544ff0ff9951fd60";